export const sucursales = [
    {value: "AY", name: "Ayutla"},
    {value: "TY", name: "Tonaya"},
    {value: "LH", name: "La huerta"},
    {value: "ST", name: "San Martín Hidalgo"},
    {value: "CH", name: "Cihuatlán"},
    {value: "UT", name: "Unión de Tula"},
    {value: "TX", name: "Tenamaxtlán"},
    {value: "ET", name: "Etzatlán"},
    {value: "VP", name: "Villa Purificación"},
    {value: "CT", name: "Cuautla"},
    {value: "MX", name: "Mixtlán"},
    {value: "VL", name: "Los volcanes"},
    {value: "ZP", name: "Zapotiltic"},
    {value: "AU", name: "Autlán de navarro"},
    {value: "SM", name: "Ameca"},
    {value: "PV", name: "Puerto Vallarta"},
    {value: "GR", name: "El Grullo"},
    {value: "CC", name: "Casimiro Castillo"},
    {value: "ZG", name: "Zapotlán el Grande"},
    {value: "TO", name: "Tomatlán"},
    {value: "MZ", name: "Manzanillo"},
    {value: "TE", name: "Tecolotlán"},
    {value: "TL", name: "Tala"},
    {value: "CL", name: "Colima"},
    {value: "SY", name: "Sayula"},
    {value: "GD", name: "Guadalajara"},
    {value: "GF", name: "Gómez Farías"},
    {value: "SG", name: "San Gabriel"},
    {value: "MS", name: "Mascota"},
    {value: "LV", name: "Las villas"},
    {value: "FR", name: "Forum"},
    {value: "VA", name: "Villa de Álvarez"},
    {value: "TA", name: "Tamazula"},
]